import styled from 'styled-components'

const WidthLabel = styled.p`
  position: absolute;
  right: 24%;
  top: 20%;
`

export default WidthLabel
